import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/60">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-900">
                Vigorbuy<span className="text-primary-500">Spread</span>
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
              The ultimate resource hub for Vigorbuy Spreadsheet guides, product discovery and smart shopping strategies.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Popular Categories</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Shopping Guides</h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/vigorbuy-spreadsheet-beginner-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Beginner Guide</Link>
              <Link to="/article/vigorbuy-spreadsheet-shoes-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Shoes Guide</Link>
              <Link to="/article/vigorbuy-spreadsheet-jackets-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Jackets Guide</Link>
              <Link to="/article/vigorbuy-spreadsheet-bags-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Bags Guide</Link>
              <Link to="/article/vigorbuy-spreadsheet-safety-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Safety Guide</Link>
              <Link to="/article/vigorbuy-spreadsheet-qc-photo-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">QC Photo Guide</Link>
              <Link to="/article/vigorbuy-spreadsheet-price-comparison-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Price Guide</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Home</Link>
              <Link to="/article/vigorbuy-spreadsheet-beginner-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Shopping Guide</Link>
              <a href={siteConfig.mainSite} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Visit Main Site</a>
              <a href="#categories" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Categories</a>
              <a href="#safety" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Safety</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={siteConfig.mainSite}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap"
            >
              Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}